exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.designer-switch {\n    margin: 0;\n    max-height: 40px;\n}\n\n", ""]);

// exports
